import typeOf from '../../helpers/typeOf';

export const getDeedForGoalActions = (data) => {
    let list = {};
    let unavailable = [];

    if (process.env.NODE_ENV === 'development') {
        if (Math.random() > 0.95) {
            unavailable = [12,14,78,65,125];
        }
    }

    data.map((item = {}) => {
        if (!typeOf.isObject(item)) {
            unavailable.push(item);
            return;
        }
        if (item.ConversionId) {
            // for conversion list
            const action = {
                idGoalAction: item.ConversionId,
                title: item.GoalActionAction
            };

            if (!(item.OfferId in list)) {
                list[item.OfferId] = {
                    title: item.Offer,
                    list: {}
                };
            }

            let goals = list[item.OfferId].list;

            if (!(item.GoalId in goals)) {
                goals[item.GoalId] = {
                    title: item.Goal,
                    list: {}
                };
            }

            let actions = list[item.OfferId].list[item.GoalId].list;

            actions[item.GoalActionActionId] = action;
        } else {
            // for history list
            const goal = item.goal || {};
            const offer = (goal && goal.offer) || item.offer || {};
            const action = item.action || {};

            action.idGoalAction = item.id;

            if (!offer.id) {
                unavailable.push(item);
                return;
            }

            if (!(offer.id in list)) {
                list[offer.id] = {
                    title: offer.title,
                    list: {}
                };
            }

            let goals = list[offer.id].list;

            const goalId = goal.id;
            if (!goalId) {
                unavailable.push(item);
                return;
            }

            if (!(goalId in goals)) {
                goals[goal.id] = {
                    title: goal.title,
                    list: {}
                };
            }

            let actions = list[offer.id].list[goal.id].list;

            if (action.id) {
                actions[action.id] = action;
            }
        }
    });

    return {
        list,
        unavailable
    };
};
